module.exports = __webpack_public_path__ + "img/Feature2-0.7ee8d736.png";